import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { topOfElementInViewportHeight, elementInViewport } from "./utilities.js";

//-----------------------------------------------
// Fade elements in on scroll
//-----------------------------------------------

function fadeInOnScroll(selector) {
	const els = gsap.utils.toArray(selector);
	els.forEach(el => {
		let delay = 0;
		delay = el.dataset.delay;
		delay = delay ? delay : 0;

		let markers = false;
		markers = el.dataset.markers;
		markers = markers ? true : false;

		let inViewportDelay = 0;
		inViewportDelay = el.dataset.inVhDelay;
		inViewportDelay = inViewportDelay ? inViewportDelay : 0;

		let duration = 2;
		duration = el.dataset.duration;
		duration = duration ? duration : 2;

		let ease = "power4.out";
		ease = el.dataset.ease;
		ease = ease ? ease : "power4.out";

		if (topOfElementInViewportHeight(el)) {
			gsap.to(el, {
				opacity: 1,
				y: 0,
				duration: duration,
				ease: ease,
				delay: inViewportDelay,
			});
		} else {
			let enter = "90%";
			enter = el.dataset.enter;
			enter = enter ? enter : "90%";

			ScrollTrigger.create({
        trigger: el,
        start: "0px " + enter,
        markers: false,
        onEnter: () => {
          gsap.to(el, {
            opacity: 1,
            y: 0,
            duration: duration,
            ease: ease,
            delay: delay,
          });
        },
      });
		}
	});
}

// The bundle is deferred, so the DOM is fully parsed before this runs —
// the old setTimeout(200) existed to wait for parsing and is no longer
// needed. One rAF keeps a settled layout frame before tweens start.
requestAnimationFrame(() => {
	fadeInOnScroll(".fade-in");
	fadeInOnScroll(".fade-in-up");
});

//-----------------------------------------------
// Fade in up zoom on scroll
//-----------------------------------------------

function fadeInUpZoomOnScroll(selector) {
	const els = gsap.utils.toArray(selector);
	els.forEach(el => {
		let delay = 0;
		delay = el.dataset.delay;
		delay = delay ? delay : 0;

		let markers = false;
		markers = el.dataset.markers;
		markers = markers ? true : false;

		let inViewportDelay = 0;
		inViewportDelay = el.dataset.inVhDelay;
		inViewportDelay = inViewportDelay ? inViewportDelay : 0;

		let duration = 2;
		duration = el.dataset.duration;
		duration = duration ? duration : 2;

		let ease = "power4.out";
		ease = el.dataset.ease;
		ease = ease ? ease : "power4.out";

		if (topOfElementInViewportHeight(el)) {
			gsap.to(el, {
				autoAlpha: 1,
				y: 0,
				duration: duration,
				ease: ease,
				delay: inViewportDelay,
			});

			gsap.to(el.querySelector('img'), {
				scale: 1.1,
				duration: 13,
				ease: ease,
			});
		} else {
			let enter = "90%";
			enter = el.dataset.enter;
			enter = enter ? enter : "90%";

			ScrollTrigger.create({
				trigger: el,
				start: '-75px ' + enter,
				markers: markers,
				onEnter: () => {
					gsap.to(el, {
						autoAlpha: 1,
						y: 0,
						duration: duration,
						ease: ease,
						delay: delay,
					});

					gsap.to(el.querySelector('img'), {
						scale: 1.1,
						duration: 13,
						ease: ease,
					});
				},
			});
		}
	});
}

requestAnimationFrame(() => {
	fadeInUpZoomOnScroll('.fade-in-up-zoom');
});

//-----------------------------------------------
// Stagger in Text on scroll
//-----------------------------------------------

// function staggerInTextOnScroll() {
// 	const els = gsap.utils.toArray('.stagger-in-text');
// 	els.forEach(el => {
// 		let delay = 0;
// 		delay = el.dataset.delay;
// 		delay = delay ? delay : 0;

// 		let inViewportDelay = 0;
// 		inViewportDelay = el.dataset.inVhDelay;
// 		inViewportDelay = inViewportDelay ? inViewportDelay : 0;

// 		let duration = .5;
// 		duration = el.dataset.duration;
// 		duration = duration ? duration : .5;

// 		let stagger = .03;
// 		stagger = el.dataset.stagger;
// 		stagger = stagger ? stagger : .03;

// 		let target = el.querySelector(el.dataset.target);
// 		target = target ? target : el;
// 		const type = el.dataset.type;

// 		const splitText = new SplitText(target, {
// 			type: type,
// 			linesClass: "stagger-in-text__el",
// 			wordsClass: "stagger-in-text__el",
// 			charsClass: "stagger-in-text__el",
// 		});

// 		if (topOfElementInViewportHeight(el)) {
// 			gsap.to(splitText[type], {
// 				duration: duration,
// 				delay: inViewportDelay,
// 				y: 0,
// 				autoAlpha: 1,
// 				ease: "back.inOut(4)",
// 				stagger: stagger,
// 				scrollTrigger: {
// 					trigger: el,
// 					start: "top 90%",
// 					markers: false,
// 				}
// 			});
// 		} else {
// 			gsap.to(splitText[type], {
// 				duration: duration,
// 				delay: delay,
// 				y: 0,
// 				autoAlpha: 1,
// 				ease: "back.inOut(4)",
// 				stagger: stagger,
// 				scrollTrigger: {
// 					trigger: el,
// 					start: "top 90%",
// 					markers: false,
// 				}
// 			});
// 		}
// 	});
// }

// staggerInTextOnScroll();